import axios from 'axios';

export default {
    methods: {
        async loadCurrencies() {
            try {
                const response = await axios.get('currencies', { params: { pageSize: -1 } });
                return response.data;
            } catch (error) {
                console.error("Error loading currencies:", error);
                return [];
            }
        },
        currencyDisplayText(item) {
            return item ? `${item.name} - ${item.code}` : '';
        }
    }
};